import React, {
	useState, useEffect
}from "react"
import {
	Table, Form
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	repetitionActions
}from "./store/actions"
import LocalLoading from "../../../components/Loading/Local"
import localization from "./localization"
import "antd/lib/table/style/index.css"
import { Link } from "react-router-dom/cjs/react-router-dom"
import "../../../pagination.css"
import "./style.css"
const { Column } = Table

const GetPotentialRepeatedReOrgAppeals = ({
	 form, initialValue, ...otherProps 
	}) => {
	const dispatch = useDispatch()
	const [selectedAppealIds, setSelectedAppealIds] = useState(initialValue ?? [])
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const { potentialRepeatedReOrgAppeals, getPotentialRepeatedReOrgAppealsLoading } = useSelector((state) => state.repetitionReducer)

	useEffect(() => {
		getPotentialRepeatedReOrgAppeals(1)
		return () => {
			form.resetFields(["PreviousAppealIds"])
		}
	}, [])

	useEffect(() => {
		form.setFieldsValue({ PreviousAppealIds: selectedAppealIds })
	}, [selectedAppealIds])

	function getPotentialRepeatedReOrgAppeals(page){
		if(!getPotentialRepeatedReOrgAppealsLoading){
			dispatch(repetitionActions.getPotentialRepeatedReOrgAppeals({
				reOrgAppealId				  : otherProps.reOrgAppealId,
				orgCreatorId                  : otherProps.orgCreatorId,
				applicantFirstName            : otherProps.applicantFirstName,
				applicantMiddleName           : otherProps.applicantMiddleName,
				applicantLastName             : otherProps.applicantLastName,
				page						  : page,
				pageSize 					  : 5
			}))
		}
	}

	const getParsedData = () => {
		return potentialRepeatedReOrgAppeals.items.map((e, index) => {
			return {
				key          : e.id,
				regNumber    : <Link to={`/appeal/${ e.id }`} target="_blank">{e.appeal.regNumber}</Link>,
				address		 : e.address,
				registerDate :
          e.registerDate && new Date(e.registerDate).toLocaleDateString(),
				applicant        : `${ e.appeal.applicantLastName } ${ e.appeal.applicantFirstName }`,
				status           : e.status[`name${ isRu ? "" : "Bel" }`],
				isCorrespondenceTerminated: e.isCorrespondenceTerminated ? "Да" : "Нет"
			}
		})
	}

	const getColumn = (title, key, width) => {
		return (<Column
			key={ key }
			dataIndex={ key }
			title={ title }
			width={ width }
		        />)
	}

	const appealSelection = {
		selectedRowKeys : selectedAppealIds,
		onChange        : (e) => {
			setSelectedAppealIds(e)
		}
	}

	return potentialRepeatedReOrgAppeals ? (
		<section className="repeat-appeals-form">
			<div>
				{ " " }
				<Form.Item
					labelCol={ { span: 0 } }
					name="PreviousAppealIds"
					rules={ [
						{
							required : true,
							message  : localization.previousAppealRequired[isRu]
						}
					] }
					wrapperCol={ { span: 24 } }
				>
					<span>
						{ isRu ? "Список повторных обращений" : "Спіс паўторных зваротаў" }
					</span>
					<Table
						dataSource={ getParsedData() }
						locale={ { Empty: localization.noData[isRu] } }
						pagination={ {
							current         : potentialRepeatedReOrgAppeals?.page ?? 1,
							pageSize        : potentialRepeatedReOrgAppeals?.pageSize ?? 10,
							total           : potentialRepeatedReOrgAppeals?.count,
							showSizeChanger : false,
							position        : ['bottomCenter']
						} }
						rowSelection={ {
							type: "checkbox",
							...appealSelection
						} }
						onChange={ (pagination) => getPotentialRepeatedReOrgAppeals(pagination.current) }
					>
						{ getColumn(localization.regNumber[isRu], "regNumber", 150) }
						{ getColumn(localization.registerDate[isRu], "registerDate", 200) }
						{ getColumn(localization.address[isRu], "address", 200) }
						{ getColumn(localization.status[isRu], "status", 200) }
						{ getColumn(localization.IsCorrespondenceTerminated[isRu], "isCorrespondenceTerminated", 200) }
					</Table>
				</Form.Item>
			</div>
		</section>
	) : (
		<LocalLoading />
	)
}

export default GetPotentialRepeatedReOrgAppeals
